import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=2a2b56fd&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2b56fd')) {
      api.createRecord('2a2b56fd', component.options)
    } else {
      api.reload('2a2b56fd', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=2a2b56fd&", function () {
      api.rerender('2a2b56fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/HomeVantage/Summaries/Tabs/Summary.vue"
export default component.exports